import { Itinerary } from './itineray.model';
import { BaseEntityService } from "./base-entity.service";
import { Injectable } from "@angular/core";

import { AngularFirestore } from "@angular/fire/firestore";
import { ItinerarySnapshot } from './itinerary-snapshot.model';

export class ItinerarySnapshotService extends BaseEntityService<
  ItinerarySnapshot
  > {
  constructor(db: AngularFirestore, itineraryId: string) {
    super(db, ItinerarySnapshot, "itineraries/" + itineraryId + "/", "snapshots");
  }
}

@Injectable({
  providedIn: "root"
})
export class ItinerarySnapshotServiceFactory {
  constructor(private db: AngularFirestore) {

  }

  create(itineraryId: string): ItinerarySnapshotService {
    return new ItinerarySnapshotService(this.db, itineraryId);
  }
}
